import LOGO from './images/logo/GWCLogo.svg';

/* Icons */
import ADD from './images/icons/add.svg';
import ASSET from './images/icons/asset.svg';
import BACK from './images/icons/back.svg';
import BARCODE from './images/icons/barcode.svg';
import BLOCK from './images/icons/block.svg';
import BOQ from './images/icons/boq.svg';
import CITY from './images/icons/city.svg';
import COMPANY from './images/icons/companies.svg';
import COUNTRY from './images/icons/country.svg';
import DASHBOARD from './images/icons/dashboard.svg';
import DELETE from './images/icons/delete.svg';
import DEPARTMENT from './images/icons/department.svg';
import DOWNLOAD from './images/icons/download.svg';
import DOWNLOAD_BLACK from './images/icons/download_black.svg';
import EDIT from './images/icons/edit.svg';
import PLAN from './images/icons/floor-plan.svg';
import HELPGRAY from './images/icons/help-gray.svg';
import HELP from './images/icons/help.svg';
import HISTORY from './images/icons/history.svg';
import INDUSTRY from './images/icons/industry.svg';
import INVITE from './images/icons/invite.svg';
import LOCATION from './images/icons/location.svg';
import MAINTANENCE from './images/icons/maintanence.svg';
import MODEL from './images/icons/model.svg';
import NOTIFICATION from './images/icons/notification.svg';
import PRINT from './images/icons/print.svg';
import PRINT_BLACK from './images/icons/print_black.svg';
import REPORTS from './images/icons/reports.svg';
import SEARCH from './images/icons/search.svg';
import SETTINGS from './images/icons/settings.svg';
import STATE from './images/icons/state.svg';
import TRACK from './images/icons/track.svg';
import TRANSFER from './images/icons/transfer.svg';
import DISPOSAL from './images/icons/disposal.svg';
import UPLOAD from './images/icons/upload.svg';
import VIEW from './images/icons/view.svg';

const Images = {
  LOGO,
  ADD,
  DASHBOARD,
  ASSET,
  TRACK,
  MAINTANENCE,
  REPORTS,
  PLAN,
  COUNTRY,
  STATE,
  CITY,
  LOCATION,
  INDUSTRY,
  COMPANY,
  DEPARTMENT,
  SETTINGS,
  HELP,
  HELPGRAY,
  NOTIFICATION,
  VIEW,
  EDIT,
  DELETE,
  BLOCK,
  HISTORY,
  UPLOAD,
  DOWNLOAD,
  BACK,
  SEARCH,
  PRINT,
  MODEL,
  BOQ,
  BARCODE,
  DOWNLOAD_BLACK,
  PRINT_BLACK,
  INVITE,
  TRANSFER,
  DISPOSAL
};

export default Images;
